import { LocalizationService } from 'services/LocalizationService'

const name = 'LOCALIZATION'

async function execute() {
  const lang = game.models.GameModel.I18n.toLowerCase()
  const response = await fetch(`i18n/${lang}.json`)
  const localization = await (response.ok
    ? response
    : await fetch('i18n/en.json')).json()
  LocalizationService.set(localization)
}

export function getLocalizationAction() {
  return {
    name,
    execute,
  }
}
